import { 
  Home, 
  MessageSquare,
  BookOpen,
  Newspaper,
  UtensilsCrossed,
  Users, 
  Calendar, 
  Building2, 
  Briefcase,
  Apple,
  Leaf,
  Video,
  Sprout,
  Sparkles
} from 'lucide-react';

export const socialItems = [
  { icon: Home, label: 'nav.newsFeed', path: '/' },
  { icon: Users, label: 'nav.communities', path: '/communities' },
  { icon: MessageSquare, label: 'nav.conversations', path: '/conversations' },
  { icon: Video, label: 'nav.liveStream', path: '/live-stream' },
];

export const discoverItems = [
  {
    icon: Calendar,
    label: 'nav.events',
    path: '/events',
    description: 'navDescriptions.events'
  },
  {
    icon: Users,
    label: 'nav.practitioners',
    path: '/practitioners',
    description: 'navDescriptions.practitioners'
  },
  {
    icon: Building2,
    label: 'nav.venues',
    path: '/venues',
    description: 'navDescriptions.venues'
  },
  {
    icon: Briefcase,
    label: 'nav.jobs',
    path: '/jobs',
    description: 'navDescriptions.jobs'
  },
];

export const learnItems = [
  {
    icon: BookOpen,
    label: 'nav.courses',
    path: '/courses',
    description: 'navDescriptions.courses'
  },
  {
    icon: UtensilsCrossed,
    label: 'nav.recipes',
    path: '/recipes',
    description: 'navDescriptions.recipes'
  },
  {
    icon: Newspaper,
    label: 'nav.articles',
    path: '/articles',
    description: 'navDescriptions.articles'
  },
  {
    icon: Apple,
    label: 'nav.nutrition',
    path: '/tools/nutrition',
    description: 'navDescriptions.nutrition'
  },
];

export const toolsItems = [
// COMMENTED OUT: Astro Chart Tool
// {
//   icon: Sparkles,
//   label: 'nav.horaryAstrology',
//   path: '/tools/horary-astrology',
//   description: 'navDescriptions.horaryAstrology'
// },
// COMMENTED OUT: Garden/Agriculture Tool
// {
//   icon: Sprout,
//   label: 'nav.myGarden',
//   path: '/gardens',
//   description: 'navDescriptions.myGarden'
// },
];
